import { GetCallContactList, useRenameCallListMutation } from "@bonliva-crm/graphql";
import { CallOrContactList, HookProps } from "../utils";

export function useUpdateCallListName(props: HookProps) {
  const [renameCallListMutation] = useRenameCallListMutation({
    onError: (e) => {
      console.error(e);
      props.onError && props.onError(e);
    },
    onCompleted: () => {
      props.onCompleted && props.onCompleted();
    }
  });

  const renameCallList = (args: { callList: CallOrContactList; newName: string }) => {
    renameCallListMutation({
      variables: {
        id: args.callList._id,
        newName: args.newName
      },
      optimisticResponse: (vars) => {
        return {
          submit: {
            __typename: "CallListOpResult",
            callList: {
              ...args.callList,
              name: vars.newName
            }
          }
        };
      },
      refetchQueries: [GetCallContactList.OperationName]
    });
  };

  return { renameCallList };
}
